import React from "react";

import FormInput from "../../Inputs/FormInput";
import FormSelect from "../../Inputs/FormSelect";
import Button from "../../Button";

import styles from "./pageModal.module.css";

const QuotationModalForm = ({
  formFields,
  formData,
  errors,
  readOnly,
  productOptions,
  quotationItems,
  handleQuotationItemChange,
  addQuotationItemRow,
  removeQuotationItemRow,
  getFieldLabel,
  normalizeSelectValue,
  handleChange,
  costFields,
}) => {
  const quotationFields = formFields.filter(
    (field) => field.section === "Quotation Details" || !field.section,
  );

  return (
    <>
      <div className={styles.formSection}>
        <h3 className={styles.sectionTitle}>Quotation Details</h3>
        <div className={styles.formGrid}>
          {quotationFields.map((field) => {
            if (field.type === "select") {
              return (
                <FormSelect
                  key={field.name}
                  label={getFieldLabel(field)}
                  name={field.name}
                  value={formData[field.name] || ""}
                  options={field.options || []}
                  error={errors[field.name]}
                  disabled={readOnly || field.disabled}
                  onChange={(e) =>
                    handleChange(field.name, normalizeSelectValue(field, e.target.value))
                  }
                />
              );
            }

            return (
              <FormInput
                key={field.name}
                label={getFieldLabel(field)}
                name={field.name}
                type={field.type}
                decimalPlaces={field.type === "number" ? 2 : undefined}
                error={errors[field.name]}
                value={formData[field.name] || ""}
                disabled={readOnly || field.disabled}
                onChange={(e) => handleChange(field.name, e.target.value)}
              />
            );
          })}
        </div>
      </div>

      <div className={styles.formSection}>
        <div className={styles.partHeaderRow}>
          <h3 className={styles.sectionTitle}>Product Details</h3>
          {!readOnly && (
            <Button type="button" variant="primary" className="h-25" onClick={addQuotationItemRow}>
              <i className="bi bi-plus-lg"></i>
            </Button>
          )}
        </div>

        {errors.quotation_items && (
          <div className={styles.partRowError}>{errors.quotation_items}</div>
        )}

        {quotationItems.map((row, rowIndex) => (
          <div key={`quotation-row-${rowIndex}`} className={styles.quotationRowGrid}>
            <FormSelect
              label="Product Name"
              name={`product_management_fid_${rowIndex}`}
              value={row.product_management_fid || ""}
              options={productOptions}
              error={errors[`quotation_items_${rowIndex}_product_management_fid`]}
              disabled={readOnly}
              onChange={(e) =>
                handleQuotationItemChange(rowIndex, "product_management_fid", e.target.value)
              }
            />
            <FormInput
              label="Volume"
              type="number"
              decimalPlaces={2}
              value={row.volume || ""}
              disabled={readOnly}
              onChange={(e) => handleQuotationItemChange(rowIndex, "volume", e.target.value)}
            />
            <FormInput
              label="Quantity"
              type="number"
              decimalPlaces={2}
              value={row.quantity || ""}
              error={errors[`quotation_items_${rowIndex}_quantity`]}
              disabled={readOnly}
              onChange={(e) => handleQuotationItemChange(rowIndex, "quantity", e.target.value)}
            />
            <FormInput
              label="Rate"
              type="number"
              decimalPlaces={2}
              value={row.rate || ""}
              error={errors[`quotation_items_${rowIndex}_rate`]}
              disabled={readOnly}
              onChange={(e) => handleQuotationItemChange(rowIndex, "rate", e.target.value)}
            />
            <FormInput 
              label="Amount" 
              type="number" 
              decimalPlaces={2} 
              value={row.amount ? Number(row.amount).toFixed(2) : ""} 
              disabled 
            />
            {!readOnly && (
              <div className={styles.partDeleteCell}>
                <Button
                  type="button"
                  variant="primary"
                  className="w-25 h-25"
                  onClick={() => removeQuotationItemRow(rowIndex)}
                >
                  <i className="bi bi-dash-lg"></i>
                </Button>
              </div>
            )}
          </div>
        ))}

        <div className={styles.quotationCostWrap}>
          {costFields.map((field) => (
            <div key={field.name} className={styles.costInlineRow}>
              <label className={styles.costInlineLabel}>{field.label}</label>
              <FormInput
                type="number"
                decimalPlaces={2}
                // className={styles.costInlineInput}
                value={formData[field.name] ?? ""}
                disabled={readOnly || field.disabled}
                onChange={(e) => handleChange(field.name, e.target.value)}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default QuotationModalForm;
